import React, { useMemo, useEffect, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { ConfettiPiece } from './ConfettiPiece';

export default function Confetti({
  count = 250,
  duration = 1000,
  width = 0,
  height = 0,
  offsetY = 0,
  offsetX = 0,
  milestoneReached = false,
}: {
  count: number;
  duration: number;
  width: number;
  height: number;
  offsetY?: number;
  offsetX?: number;
  milestoneReached: boolean;
}) {
  const centerX = width / 2 - offsetY;
  const centerY = height / 2 - offsetX;

  const [triggerExplosion, setTriggerExplosion] = useState(false);

  useEffect(() => {
    let startTimeout: NodeJS.Timeout;
    let endTimeout: NodeJS.Timeout;
    if (milestoneReached) {
      startTimeout = setTimeout(() => {
        setTriggerExplosion(true);
      }, 500);
      endTimeout = setTimeout(() => {
        setTriggerExplosion(false);
      }, 1000 + duration);
    } else {
      setTriggerExplosion(false);
    }
    return () => {
      clearTimeout(startTimeout);
      clearTimeout(endTimeout);
    };
  }, [milestoneReached]);

  const pieces = useMemo(() => Array.from({ length: count }), [count]);

  return (
    triggerExplosion && (
      <View style={[StyleSheet.absoluteFill, { width, height, pointerEvents: 'none' }]}>
        {pieces.map((_, i) => (
          <ConfettiPiece
            key={'Confetti' + i}
            centerX={centerX}
            centerY={centerY}
            duration={duration}
            triggerExplosion={triggerExplosion}
          />
        ))}
      </View>
    )
  );
}
